import i18n from '@assets/i18n/config';
import {
  buildWorkflowLaunchInput,
  type WorkflowLaunchError,
  type WorkflowLaunchParams,
} from '@utils/buildWorkflowLaunchInput';
import { FlagsmithFlags } from '@utils/flagsmith';
import { useToast } from 'hephaestus/web';
import { useCallback, useRef } from 'react';
import { useFeatureFlag } from './useFeatureFlag';

export type WorkflowLaunchToastError = WorkflowLaunchError | 'createFailed';

export const useWorkflowLaunchError = () => {
  const { enqueueToast } = useToast();
  const enqueueToastRef = useRef(enqueueToast);
  enqueueToastRef.current = enqueueToast;

  return useCallback(
    (error: WorkflowLaunchToastError) =>
      enqueueToastRef.current(
        i18n.t(`workflowCompletions:workflowLaunch.errors.${error}`),
        { variant: 'error' },
      ),
    [],
  );
};

export const useWorkflowLaunchInput = () => {
  const withContext = useFeatureFlag(FlagsmithFlags.context_aware_workflows);
  const reportLaunchError = useWorkflowLaunchError();

  return useCallback(
    (params: Omit<WorkflowLaunchParams, 'withContext'>) => {
      const launch = buildWorkflowLaunchInput({ ...params, withContext });
      if ('error' in launch) reportLaunchError(launch.error);
      return launch;
    },
    [withContext, reportLaunchError],
  );
};
